var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOjitoAbierto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99994 11.7474C7.48358 11.7474 6.25244 10.5163 6.25244 8.99994C6.25244 7.48358 7.48358 6.25244 8.99994 6.25244C10.5163 6.25244 11.7474 7.48358 11.7474 8.99994C11.7474 10.5163 10.5163 11.7474 8.99994 11.7474ZM8.99994 6.37744C7.5538 6.37744 6.37744 7.5538 6.37744 8.99994C6.37744 10.4461 7.5538 11.6224 8.99994 11.6224C10.4461 11.6224 11.6224 10.4461 11.6224 8.99994C11.6224 7.5538 10.4461 6.37744 8.99994 6.37744Z",
    stroke: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10894 10.981L2.10823 10.9799C1.77368 10.4591 1.59131 9.74477 1.59131 9.00292C1.59131 8.26141 1.77354 7.54474 2.10869 7.01963C3.87716 4.26251 6.39653 2.73511 9.00006 2.73511C11.6038 2.73511 14.1229 4.26268 15.8837 7.01926L15.8844 7.02036C16.2189 7.54111 16.4013 8.25545 16.4013 8.9973C16.4013 9.73901 16.219 10.4559 15.8836 10.981C14.1229 13.7376 11.6038 15.2651 9.00006 15.2651C6.38861 15.2651 3.86953 13.7373 2.10894 10.981ZM9.00006 2.86011C6.3643 2.86011 3.90504 4.44214 2.21875 7.08835C1.87235 7.62907 1.71818 8.33206 1.71818 9.00011C1.71818 9.66792 1.87224 10.3706 2.21838 10.9113C3.90468 13.5578 6.36411 15.1401 9.00006 15.1401C11.6358 15.1401 14.0951 13.5581 15.7814 10.9119C16.1278 10.3711 16.2819 9.66816 16.2819 9.00011C16.2819 8.33204 16.1278 7.62902 15.7813 7.08829C14.095 4.44212 11.6358 2.86011 9.00006 2.86011Z",
    stroke: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjitoAbierto);
export default __webpack_public_path__ + "static/media/ojito_abierto.159f6e4f0a50c02f8645d1b61d3a8bc9.svg";
export { ForwardRef as ReactComponent };